'use client'
import { useEffect, useRef, useState } from 'react'

/** Seed the first snapshot silently; highlight only entries added by later refreshes. */
export default function useFeedBlips(keys: string[], timestamps?: number[]) {
 const newest = useRef(0)
 const previous = useRef<Set<string> | null>(null)
 const [fresh, setFresh] = useState<Set<string>>(new Set())
 const signature = JSON.stringify(keys.map((key, index) => ({ key, time: timestamps?.[index] ?? null })))
 useEffect(() => {
  const entries = JSON.parse(signature) as { key: string; time: number | null }[]
  const current = entries.map(entry => entry.key)
  if (!current.length) return
  const added = previous.current ? entries.filter(entry => !previous.current!.has(entry.key) && (entry.time === null || entry.time > newest.current)).map(entry => entry.key) : []
  previous.current = new Set(current)
  newest.current = Math.max(newest.current, ...entries.map(entry => entry.time ?? 0))
  const show = setTimeout(() => setFresh(new Set(added)), 0)
  const clear = setTimeout(() => setFresh(new Set()), 1800)
  return () => { clearTimeout(show); clearTimeout(clear) }
 }, [signature])
 return fresh
}
